import { useEffect, useState } from 'react';

import { Box, Grid, Stack } from '@mui/material';
import { logEvent } from 'firebase/analytics';
import { useNavigate } from 'react-router-dom';

import { CommonTable, IDOCard, LoadingHOC } from '../../common_components';
import { isMobile, PAST_IDO } from '../../common_components/constants';
import { ongoingIDOColumns } from '../../common_components/IDOTable/columns';
import { ColorButton } from '../../common_components/styled';
import analytics from '../../firebase';
import { useFetchPastIdos } from '../../hooks/useClientDataService';
import '../styles.scss';

const PastIDO = () => {
  const navigate = useNavigate();
  const [isTableViewSelected, setIsTableViewSelected] = useState(
    localStorage.getItem('display-type')
      ? localStorage.getItem('display-type') === 'table'
      : isMobile
  );
  useEffect(() => {
    logEvent(analytics, 'PAST_IDO');
  }, []);

  useEffect(() => {
    setIsTableViewSelected(
      localStorage.getItem('display-type')
        ? localStorage.getItem('display-type') === 'table'
        : isMobile
    );
  }, [localStorage.getItem('display-type')]);

  const { data: pastIDOsList, hasNextPage, isLoading, fetchNextPage } = useFetchPastIdos();

  const onRowClick = (rowData) => {
    navigate(`/tokenDetails/${rowData.token_name}`);
    localStorage.setItem('tokenId', rowData.token_id);
  };

  if (isLoading) {
    return <LoadingHOC />;
  }
  return (
    <Box sx={{ m: 2, p: 2, pt: 0, mt: 0 }} elevation={3}>
      {isTableViewSelected ? (
        <CommonTable
          columns={ongoingIDOColumns}
          idoType={PAST_IDO}
          idoData={pastIDOsList}
          onRowClick={onRowClick}
        />
      ) : (
        <>
          {pastIDOsList.pages.map((page, index) => (
            <Grid container spacing={3} sx={{ mt: 0.5 }} key={index}>
              {page.items?.map((item) => (
                <Grid item xs={12} md={3} key={item.token_id}>
                  <IDOCard {...item} idoType={PAST_IDO} />
                </Grid>
              ))}
            </Grid>
          ))}
        </>
      )}

      <Stack justifyContent="center" display="flex" alignItems="center" sx={{ m: 2 }}>
        <ColorButton
          variant="contained"
          loading={false}
          onClick={fetchNextPage}
          disabled={!hasNextPage}>
          Show More
        </ColorButton>
      </Stack>
    </Box>
  );
};

export default PastIDO;
